/* eslint-disable @typescript-eslint/no-unsafe-return */
import { connect } from 'react-redux';

import { CustomAttributeDefinition } from '../../CAD.types';
import { canCreateCAD, canDeleteCAD } from '../../cache/identity.cache';
import {
	cleanCustomAttributeDefinitionsAction,
	closingCustomAttributeDelete,
	getCustomAttributeDefinitionsAction,
	goToCADAddForm,
	goToCADEditForm,
	openingCustomAttributeDefinitionDelete,
	removingCustomAttributeDefinitionAction,
} from '../../service/CADList/CADList.actions';
import {
	getCADListData,
	getCADListDeleteInProgress,
	getCADListLoading,
	getCADListShowModal,
} from '../../service/CADList/CADList.selectors';
import { CADList as Component, CADListDispatchProps, CADListMapProps } from './CADList.component';

function mapStateToProps(store: any): CADListMapProps {
	return {
		createEntitlement: canCreateCAD(),
		deleteEntitlement: canDeleteCAD(),
		deleteInProgress: getCADListDeleteInProgress(store),
		items: getCADListData(store),
		loading: getCADListLoading(store),
		showDeleteModal: getCADListShowModal(store),
	};
}

function mapDispatchToProps(dispatch: Function): CADListDispatchProps {
	return {
		onAdd: (): void => {
			dispatch(goToCADAddForm);
		},
		onClickTitle: (_: any, { id }: CustomAttributeDefinition): void => {
			dispatch(goToCADEditForm(id));
		},
		cleanCustomAttributeDefinitions: (): void => dispatch(cleanCustomAttributeDefinitionsAction),
		fetchCustomAttributeDefinitions: (): void => dispatch(getCustomAttributeDefinitionsAction),
		onClickTrash: (): void => dispatch(openingCustomAttributeDefinitionDelete()),
		onCloseDeleteModal: (): void => dispatch(closingCustomAttributeDelete()),
		onValidateDeleteCustomAttribute: (id: string, label: string): void =>
			dispatch(removingCustomAttributeDefinitionAction(id, label)),
	};
}

const CADList = connect(mapStateToProps, mapDispatchToProps)(Component);

export { CADList };
